module.exports = __webpack_public_path__ + "img/doupan.e678a4e2.png";